import type { NextPage } from 'next';

import { BlockType } from '@web/blocks';

import { ContentBlock } from '@web/components/block-list/content-block';
import { HeroBlock } from '@web/components/hero-block/hero-block';

import TemplateLayout from '@web/layouts/template/template';

import { UmbracoPage } from '@web/services/umbraco/types/documents/UmbracoDocument';
import { HeroBlockType } from '@web/services/umbraco/types/elements/Hero';

export const contentAlias = 'contentPage';

export type PageData = UmbracoPage<typeof contentAlias, {
	hero: HeroBlockType;
	blocks: BlockType[];
}>;

const PageTemplate: NextPage<{ pageData: PageData }> = ({ pageData }) => {
	return (
		<TemplateLayout>
			{pageData.properties.hero && <HeroBlock block={pageData.properties.hero} />}
			{pageData.properties.blocks && <ContentBlock blocks={pageData.properties.blocks} />}
		</TemplateLayout>
	);
};

export default PageTemplate;
